import { Entity } from '@core/entities/entity'
import { plainToInstance } from 'class-transformer'
import { ILinkedChecklistResultTemplate } from './ILinkedChecklistResultTemplate'

export class LinkedChecklistResultTemplate extends Entity<ILinkedChecklistResultTemplate> {
  id: number

  name: string

  templateVersionId: number

  version: number

  public static new(payload: unknown): LinkedChecklistResultTemplate {
    const entity = plainToInstance(LinkedChecklistResultTemplate, payload)

    return entity
  }

  public getTemplateName(): string {
    return `${this.name} (V${this.version})`
  }
}
